<template>
  <div  v-if="associations.length > 1 || businesses.length > 1">
    <div class="row">
      <div class="col-12">
        <el-alert
          class="mb-2 py-2 px-0 child mx-auto"
          :title="$t('common_words.note_guilds_or_groups')"
          type="info"
          :closable="false"
        >
        </el-alert>
      </div>
    </div>
    <div class="row">
      <select-component
        v-if="associations.length > 1"
        ref="select_associations_ids"
        rowClass="col-12 col-md-6"
        :labelSelect="`${$t('common_words.guilds_or_groups')}: ${
          requiered ? '*' : ''
        }`"
        :dataOptions="associations"
        :initialSelection="model.associations_ids"
        @onChange="handleChangeSelected"
        modelName="associations_ids"
        :requireClass="`${requiered ? 'required-' : ''}bus-rels`"
      />
      <select-component
        v-if="associations.length > 1 || businesses.length > 1"
        ref="select_businesses_ids"
        :rowClass="`col-12 ${associations.length === 1 ? `` : `col-md-6`}`"
        :labelSelect="`${$t('common_words.associated_companies2')}: ${
          requiered ? '*' : ''
        }`"
        :dataOptions="getBusinessByAssociation()"
        :initialSelection="model.businesses_ids"
        @onChange="handleChangeSelected"
        modelName="businesses_ids"
        :requireClass="`${requiered ? 'required-' : ''}bus-rels`"
      />
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import MixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import Select from './Select.vue';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    [Select.name]: Select,
  },
  name: 'select-businesses-component',
  mixins: [MixinMasters, MixinPermissions],
  props: {
    showLoading: {
      type: Boolean,
      deafult: true,
    },
    requiered: {
      type: Boolean,
      deafult: false,
    },
    initialData: {
      type: Array | null,
      deafult: null,
    },
  },
  data() {
    return {
      associations: [],
      businesses: [],
      model: {
        associations_ids: [],
        businesses_ids: [],
        names: [],
      },
    };
  },
  watch: {
    '$i18n.locale': 'getSelectAll',
  },
  methods: {
    getSelectAll() {
      this.associations = this.concatAll(this.associations.splice(1));
      this.businesses = this.concatAll(this.businesses.splice(1));
    },
    isEdit() {
      const editForm = sessionStorage.getItem('editForm');
      return this.isUpdate() && editForm !== null;
    },
    autoFillBusiness() {
      if (!sessionStorage.getItem('editForm')) {
        if (
          (this.model.businesses_ids === null ||
            this.model.businesses_ids.length === 0) &&
          this.businesses.length == 1
        ) {
          this.model.businesses_ids.push(this.businesses[0].id);
          this.$emit('onChange', this.model);
        }
      }
    },
    handleChangeSelected(data) {
      let tmp = [];
      if (data.name == 'associations_ids') {
        tmp = [...this.model.businesses_ids];
      }

      this.$set(this.model, data.name, data.selects);
      this.$set(this.model, 'names', []);

      switch (data.name) {
        case 'associations_ids':
          this.$set(this.model, 'businesses_ids', []);
          break;

        default:
          break;
      }

      this.model.associations_ids.forEach((element) => {
        this.associations.forEach((item) => {
          if (element == item.id) {
            this.model.names.push(item.name);
          }
        });
      });

      if (data.name == 'associations_ids') {
        const bsFinal = [];
        this.getBusinessByAssociation().forEach((bs) => {
          if (tmp.includes(bs.id)) bsFinal.push(bs.id);
        });

        this.$set(this.model, 'businesses_ids', bsFinal);
      }

      this.model.businesses_ids.forEach((element) => {
        this.getBusinessByAssociation().forEach((item) => {
          if (element == item.id) {
            this.model.names.push(item.name);
          }
        });
      });

      this.$emit('onChange', this.model);
    },
    getBusinessByAssociation() {
      if (this.isEdit() || this.model.associations_ids.length === 0) {
        return this.concatAll(this.businesses);
      }

      let resp = [];
      if (this.model.associations_ids.length > 0) {
        this.businesses.forEach((business) => {
          if (business.association) {
            const result = business.association.find((item) =>
              this.model.associations_ids.includes(item)
            );
            if (result) resp.push(business);
          }
        });
      }

      return this.concatAll(resp);
    },
    setBusinesses(dataBusinesses) {
      this.$set(this.model, 'associations_ids', []);
      this.$set(this.model, 'businesses_ids', []);

      dataBusinesses.forEach((element) => {
        const result = this.associations.find(
          (business) => business.id === element.id
        );

        if (result) {
          this.model.associations_ids.push(element.id);
          this.model.names.push(element.name);
        }
      });

      this.getBusinessByAssociation().forEach((element) => {
        const result = dataBusinesses.find(
          (business) => business.id === element.id
        );

        if (result) {
          this.model.businesses_ids.push(element.id);
          this.model.names.push(element.name);
        }
      });

      this.$emit('onChange', this.model);
    },
    fillUpdateData() {
      if (this.isUpdate() && sessionStorage.getItem('editForm')) {
        const editForm = JSON.parse(sessionStorage.getItem('editForm'));
        const { business, businesses } = editForm;
        this.setBusinesses(businesses ? businesses : business);
      } else if (this.isUpdate() && this.initialData) {
        this.setBusinesses(this.initialData);
      }
    },
  },
  created() {
    if (this.showLoading) this.$emit('showHideLoading', true);
    if (this.isCreate() || this.isUpdate()) {
      Promise.all([
        Axios.getMasters('businesses/associations'),
        Axios.getMasters('businesses/normal'),
      ])
        .then((response) => {
          const [response_association, response_business] = response;
          this.associations = this.concatAll(response_association.data.data);
          this.businesses = response_business.data.data;
          this.autoFillBusiness();
          this.fillUpdateData();
          if (this.showLoading) this.$emit('showHideLoading', false);
        })
        .catch((error) => {
          console.log(`${error}`);
          if (this.showLoading) this.$emit('showHideLoading', false);
          SweetAlert.warning(error.response.data.message);
        });
    } else if (this.showLoading) this.$emit('showHideLoading', false);
  },
};
</script>

